import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=32d0b328&scoped=true"
import script from "./GlobalLoading.vue?vue&type=script&lang=js"
export * from "./GlobalLoading.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=32d0b328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0b328",
  null
  
)

export default component.exports